import katex from "katex"

interface RenderMathOptions {
  latex: string
  displayMode: boolean
}

export function renderMathToHTML({
  latex,
  displayMode,
}: RenderMathOptions): string {
  if (!latex.trim()) return ""

  return katex.renderToString(latex, {
    displayMode,
    throwOnError: false,
    output: "htmlAndMathml",
  })
}
